<template>
  <bvue-ui-view :scroll="true">
	    <div class="w-full">
      <button @click="$router.go(-1)" class="link flex items-center mb-8">
         <i class="material-icons">arrow_back</i>
         <label>{{ $t('volver') }}</label>
      </button>
    </div>
<div id="fondo">
<div class="frame">
	<div id="responsive1">
		<h2>Über Árbola</h2>
		<p>ÁRBOLA ist die erste Webanwendung zur Wiederaufforstung, die dem Schutz der Artenvielfalt dient. Erstelle ein Profil mit deinem Foto, um Samen zu erhalten. Wenn du einen Samen pflanzt, wählst du die Baumart und den Ort an dem du ihn pflanzen willst aus. Mit ÁRBOLA kannst du einem endemischen oder einheimischen Baum in einen der artenreichsten Ökosystemen der Welt sponsorn.</p>
		<p>Jede Spende deckt für jeden gesponserten Baum die Einrichtung von Baumschulen, die Zaunkosten, den Wiederaufforstungsprozess und die Wartung über 3 Jahre. ÁRBOLA stellt eine direkte Verbindung zwischen dem Spender und dem Wiederaufforstungsprojekt her. Die App wurde im Mai 2019 gestartet. Wir freuen uns sehr über den anfänglichen Erfolg, benötigen aber weiterhin deine Hilfe.</p>
	</div>        
	<div class="responsive2">
		<iframe id="video" width="100%" height="100%" src="https://www.youtube.com/embed/9egA4nTzgqg?&hl=de&cc_lang_pref=de&cc_load_policy=1" frameborder="0" allowfullscreen></iframe>	
	</div>
</div>

<div class="frame">
	<div id="titulo">
		<h3>Über die Stiftung Red Forestal</h3>
	</div>
	<div class="responsive2">
		<img id="imagen" src="@/assets/imgabout/imagen1.jpg">
	</div>	
	<div id="responsive3">	
		<p>Die Stiftung Red Forestal  ist eine gemeinnützige Organisation, die 2018 in Ecuador gegründet wurde. Unser Ziel ist es, Wiederaufforstungsprojekte zum Schutz der Artenvielfalt durchzuführen.</p>
		<p>Wir wenden neue Kommunikationstechnologien an um entscheidend bei der Verbreitung des Naturschutzes in Ecuador mitzuwirken. Zu diesem Zweck erstellen wir Kooperationsnetzwerke, erarbeiten Kommunikationsmaterial und schaffen dadurch Umweltbewusstsein. Wir arbeiten mit anderen gemeinnützigen Organisationen zusammen, die sich mit dem gemeinsamen Ziel des Umwelt- und Klimaschutzes, der Förderung von Umweltdienstleistungen und des Schutzes von Lebensräumen befassen. Wir tragen dadurch zur Ausbreitung, Wiederherstellung und Erhaltung von Naturschutzgebieten und biologischen Verbindungskorridoren in Ecuador bei. </p>
		<div id="hidden1">
		<center>
			<img id="logo1" src="@/assets/imgabout/logoFundacion.jpg">
			<p class="dudas">Falls du Fragen oder Anmerkungen hast, schreib uns eine E-Mail an:<br><a href="mailto:contacto@plantavida.app">contacto@plantavida.app</a>.</p>
			<p><a href="http://redforestal.org">Weitere Information über die Stiftung findest du auf unserer Webseite.</a></p>
		</center>
		</div>
	</div>
</div>
<div id="hidden2">
	<center>
		<img src="@/assets/imgabout/logoFundacion.jpg" style="max-width: 300px">
		<p class="dudas">Falls du Fragen oder Anmerkungen hast, schreib uns eine E-Mail an:<br><a href="mailto:contacto@plantavida.app">contacto@plantavida.app</a>.</p>
		<p><a href="http://redforestal.org/de/startseite/" target="_blank">Weitere Information über die Stiftung findest du auf unserer Webseite.</a></p>
	</center>
</div>
</div>
  </bvue-ui-view>
</template>

<script>
export default {
  name: 'About_de',
  mounted() {
    this.$ga.page('/Sobre Nosotros DE');
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss">
@import '@/style/aboutresponsive.scss';

</style>


// WEBPACK FOOTER //
// src/pages/About_de.vue